import React, { ReactElement } from 'react';
import styled from 'styled-components';

const ErrorMessage = styled.div`
  font-size: 2rem;
  width: 100%;
`;

interface ErrorInterface {
  message?: ReactElement | string;
}

const Error = ({ message }: ErrorInterface) => {
  const content = message ?? 'Something went wrong';

  return <ErrorMessage>{content}</ErrorMessage>;
};

export default Error;
